exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Color Defination\r\n   ========================================================================== */\n/**\r\n * main color\r\n */\n/*main color*/\n/*main light color*/\n/*second color*/\n/*used in header*/\n/*dark text color*/\n/*light text color*/\n/*very light color*/\n/*mostly used in buttons*/\n/**/\n/**/\n/**\r\n * main color\r\n */\napp-dashboard {\n  display: block; }\n.dash-stats-card {\n  text-align: center;\n  height: 100%; }\n.dash-stats-card .fi {\n    font-size: 40px; }\n.dash-stats-card h3 {\n    color: #404040;\n    margin: 10px 0 5px !important;\n    white-space: nowrap; }\n.dash-stats-card p {\n    color: #cacaca;\n    margin: 0; }\n.dash-stats-card .fi.device {\n    color: #009eea; }\n.dash-stats-card .fi.site {\n    color: #5dd791; }\n.dash-stats-card .fi.user {\n    color: #8c4ab6; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/dashboard/dashboard.component.scss
// module id = ../../../../../src/app/dashboard/dashboard.component.scss
// module chunks = main